import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-940bf56c")

_pushScopeId("data-v-940bf56c")
const _hoisted_1 = { class: "generic-input flex flex--valign-c" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("input", {
      class: "generic-input-field",
      type: "text",
      value: _ctx.value,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      autocomplete: "off",
      autocorrect: "off",
      autocapitalize: "off",
      spellcheck: false,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 40, ["value", "placeholder", "disabled"])
  ]))
})